import React, { useState, useEffect } from "react";
import logo from '../images/Logo.png';
import '../App.css';
import { Link } from 'react-router-dom'
import { useClient } from '../context/ClientContext.tsx';
import { signOut } from 'aws-amplify/auth';
import EulaPopup from '../components/EulaPopup.js';


const Home = () => {
  const { name, organization, isAdmin, expirationDate, subscriptionIsActive, setClientInfo } = useClient();

  /*
  const isValid =
    expirationDate instanceof Date &&
    !isNaN(expirationDate) &&
    expirationDate > new Date();
  */
  const isValid = subscriptionIsActive === true
    || (expirationDate instanceof Date &&
      !isNaN(expirationDate) &&
      expirationDate > new Date());


  const handleSignOut = async () => {
    try {
      await signOut();
      console.log('User signed out');
      setClientInfo({ name: '', organization: '', isAdmin: false, expirationDate: null, subscriptionIsActive: false });
      localStorage.removeItem('clientName');
      localStorage.removeItem('clientOrganization');
      localStorage.removeItem('clientIsAdmin');
      localStorage.removeItem('clientExpirationDate');
      localStorage.removeItem('subscriptionIsActive');
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };


  const [showEula, setShowEula] = useState(false);

  useEffect(() => {
    const hasAgreed = localStorage.getItem("eulaAgreed");
    setShowEula(!hasAgreed);

    //for testing
    //setShowEula(true);

  }, []);

  const handleAgree = () => {
    localStorage.setItem("eulaAgreed", "true");
    setShowEula(false);
  };



  return (
    <div className="App">
      <style>
        {`
        .App-header {
          justify-content: flex-start !important;
          padding-top: 20px !important;
        }
        @media (max-width: 600px) {
          .App-header {
            padding-top: 10px !important;
          }
        }
        `}
      </style>

      {showEula && <EulaPopup onAgree={handleAgree} />}

      <div className='Login-out'>
        <Link to="/login">
          <button style={{ margin: '4px 10px' }}>
            Log In
          </button>
        </Link>

        <Link to="/">
          {/* <button  style={{margin: '4px 10px'}} onClick={() => auth.logOut()}> */}
          <button style={{ margin: '4px 10px' }} onClick={handleSignOut}>
            Log Out
          </button>
        </Link>


      </div>


      <header className="App-header">

        {!organization && (
          <div>Sign up for a fully functional free trial.</div>
        )}
        {organization && <p>Organization: {organization}</p>}

        {expirationDate instanceof Date && !isNaN(expirationDate) && (
          <p style={{ marginTop: '4px', fontSize: '0.85rem', color: 'rgba(255, 255, 255, 0.7)' }}>
            Expiration Date:{' '}
            {expirationDate.toLocaleDateString('en-US', {
              year: 'numeric',
              month: 'long',
              day: 'numeric',
            })}
          </p>
        )}

        {(!isValid && isAdmin) && (
          <Link to="/select-plan">
            <button style={{ margin: '4px 10px' }}>Select Plan</button>
          </Link>
        )}


        <div>
          {name && <span>Welcome, {name}</span>}
          {isAdmin && <span style={{ marginLeft: '0.5rem' }}>(Admin)</span>}
        </div>


        <img src={logo} className="App-logo" alt="logo" />
        ZippyQ
        <small><small><small>By JAB Software Solutions</small></small></small>
        <p>
          Carpool Lines made simple!
        </p>

        <div>
          {isValid && (
            <div>
              <Link to="/checkin">
                {/* <button style={{height: '30px', width : '100px'}} size="lg"> */}
                <button>
                  Arrived
                </button>
              </Link>
              <p></p>

              <Link to="/queue">
                <button style={{ margin: '4px 10px' }}>Queue</button>
              </Link>
            </div>
          )}

          {/* <button style={{margin: '4px 10px'}}>Admin</button> */}

          <Link to="/about"><button style={{ margin: '4px 10px' }}>
            About
          </button>
          </Link>

          {isAdmin === true &&
            <Link to="/admin">
              <button style={{ margin: '4px 10px' }}>Admin</button>
            </Link>
          }

        </div>

      </header>

    </div>
  );
};

export default Home;